import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBaseService } from "@gea-waldviertler-website/shop-lib";
import { StockItemInterface } from "@gea-waldviertler-website/gea-models";

@Injectable()
export class HttpStockService extends HttpBaseService {
  getStock(productSlug: string): Observable<StockItemInterface> {
    let url: string = this.getMainApiBaseUrl() + "/product/stock/" + productSlug
    return this.http.get<StockItemInterface>(url)
  }

  getCategoryStock(categoryId: number) {
    let url: string = this.getMainApiBaseUrl() + "/product/stock/all?categoryId=" + categoryId
    return this.http.get<StockItemInterface[]>(url)
  }
}
